import PropTypes from 'prop-types'
import React from 'react'

import getLabels from '../../utils/getLabels'

import SearchResultRow from '../SearchResultRow'

const SearchResult = ({
  classes,
  items,
  selectedItem,
  selectedFlights,
  order,
  ...rest
}) => {
  return Boolean(items.length) ? (
    <React.Fragment>
      <div className={classes.thead}>
        <div className={classes.cel}>{getLabels('flight_nr')}</div>
        <div className={classes.cel}>{getLabels('departure')}</div>
        <div className={classes.cel}>{getLabels('arrival')}</div>
        <div>{getLabels('allotments_left')}</div>
      </div>
      {items.map(item => (
        <SearchResultRow
          item={item}
          isActive={item.flightId === selectedItem}
          key={item.flightId}
          flightIsSelected={
            item.flightId ===
            (order === 0 ? selectedFlights.departure : selectedFlights.return)
          }
          {...rest}
        />
      ))}
    </React.Fragment>
  ) : (
    <div className={classes.celError}>
      {getLabels('error_no_flights_found')}
    </div>
  )
}

SearchResult.propTypes = {
  classes: PropTypes.shape({
    celError: PropTypes.string,
    thead: PropTypes.string,
    cel: PropTypes.string,
  }),
  search: PropTypes.shape({
    items: PropTypes.shape({
      flightId: PropTypes.string,
    }),
    selectedItem: PropTypes.string,
    route: PropTypes.object,
  }),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      flightId: PropTypes.string,
    })
  ).isRequired,
  selectedItem: PropTypes.string,
  selectedFlights: PropTypes.object,
  order: PropTypes.number,
}

export default SearchResult
